/**
 * Galeries indicateurs — préférer les exports `Alturion*` quand ils existent
 * dans `public/images/<Dossier>/`. Sinon garder les chemins legacy.
 *
 * Quand tu ajoutes de nouveaux PNG Alturion* dans un dossier, mets à jour
 * la liste ici + `backend/products.json` (images produit).
 */
export const INDICATOR_GALLERIES = {
  EnhancedSessionLevels: [
    '/images/EnhancedSessionLevels/AlturionESL1.png',
    '/images/EnhancedSessionLevels/AlturionESL2.png',
    '/images/EnhancedSessionLevels/AlturionESL3.png',
  ],
  TradingSessions: [
    '/images/TradingSessions/AlturionTradingSession1.png',
    '/images/TradingSessions/AlturionTradingSession2.png',
    '/images/TradingSessions/AlturionTradingSession3.png',
  ],
  PremiumVolumeProfile: [
    '/images/PremiumVolumeProfile/AlturionVolumeProfilePremium1.png',
    '/images/PremiumVolumeProfile/AlturionVolumeProfilePremium2.png',
    '/images/PremiumVolumeProfile/AlturionVolumeProfilePremium3.png',
    '/images/PremiumVolumeProfile/AlturionVolumeProfilePremium4.png',
  ],
  PremiumVwap: [
    '/images/PremiumVwap/AlturionVwapPremium1.png',
    '/images/PremiumVwap/AlturionVwapPremium2.png',
    '/images/PremiumVwap/AlturionVwapPremium3.png',
    '/images/PremiumVwap/AlturionVwapPremium4.png',
    '/images/PremiumVwap/AlturionVwapPremium5.png',
    '/images/PremiumVwap/AlturionVwapPremium6.png',
  ],
  LiteVolumeProfile: [
    '/images/LiteVolumeProfile/AlturionVolumeProfileLite1.png',
    '/images/LiteVolumeProfile/AlturionVolumeProfileLite2.png',
    '/images/LiteVolumeProfile/AlturionVolumeProfileLite3.png',
  ],
  LiteVwap: [
    '/images/LiteVwap/AlturionVwapLite1.png',
    '/images/LiteVwap/AlturionVwapLite2.png',
    '/images/LiteVwap/AlturionVwapLite3.png',
  ],
  ORB: [
    '/images/ORB/AlturionOPR1.png',
    '/images/ORB/AlturionOPR2.png',
    '/images/ORB/AlturionOPR3.png',
  ],
  OpenLevels: [
    '/images/OpenLevels/AlturionOpenLevels1.png',
    '/images/OpenLevels/AlturionOpenLevels2.png',
    '/images/OpenLevels/AlturionOpenLevels3.png',
  ],
  AsianSession: [
    '/images/AsianSession/AlturionAsianSession1.webp',
    '/images/AsianSession/AlturionAsianSession2.webp',
    '/images/AsianSession/AlturionAsianSession3.webp',
  ],
  RiskReward: [
    '/images/RiskReward/AlturionRiskReward1.webp',
    '/images/RiskReward/AlturionRiskReward2.webp',
    '/images/RiskReward/RR1.png',
    '/images/RiskReward/RR2.png',
    '/images/RiskReward/RR3.png',
    '/images/RiskReward/RR4.png',
  ],
  BarTimer: [
    '/images/BarTimer/AlturionBarTimer1.png',
    '/images/BarTimer/AlturionBarTimer2.png',
    '/images/BarTimer/AlturionBarTimerTicks.webp',
    '/images/BarTimer/AlturionBarTimerRange5.webp',
    '/images/BarTimer/AlturionBarTimer3.png',
  ],
};
